/*
 * Copyright (c) 2025-2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React from 'react';
import {CatalogAPI} from "../APIs/CatalogApi.js";
import ContainerPage from "./ContainerPage.jsx";
import PagePage from "./PagePage.jsx";
import EmptyStateBig from "../components/EmptyState/EmptyStateBig.jsx";

function CatalogPage({catalogId}) {

    const [catalogInfo, setCatalogInfo] = React.useState({});
    const [isLoaded, setIsLoaded] = React.useState(false);

    React.useEffect(() => {
        const fetchData = async () => {
            let result = await CatalogAPI.info(catalogId)
            setCatalogInfo(result?.catalogInfo ?? result ?? {})
            setIsLoaded(true)
        };
        fetchData();
    }, [catalogId]);

    if (!isLoaded) {
        return (<div>Loading catalog info. {catalogId}</div>)
    }

    if (!catalogInfo?.indexKey) {
        return (<EmptyStateBig iconName={"Container"} text={`Catalog item not found. (catalogId: ${catalogId})`}/>)
    }

    if (catalogInfo.type === "app") {
        return <ContainerPage containerId={"container-" + catalogInfo.indexKey}/>
    }

    if (catalogInfo.type === "page") {
        return <PagePage pageId={catalogInfo.indexKey}/>
    }

    return (<EmptyStateBig iconName={"Container"}
                           text={`Catalog ${catalogInfo.name} type item not found. (catalogId: ${catalogId}, type:${catalogInfo.type})`}/>)

}

CatalogPage.propTypes = {};

CatalogPage.defaultProps = {};


export default CatalogPage;